// A reference is a UUID in its canonical printed form. Checking the shape
// here keeps a mistyped reference off the network entirely. Deliberately
// stricter than the server, which also accepts brace-wrapped, urn: and
// undashed forms -- none of which is ever printed on a document.
const CANONICAL_UUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const REFERENCE_LENGTH = 36;

const isWellFormedReference = (reference: string | undefined): boolean =>
  typeof reference === "string" && CANONICAL_UUID.test(reference);

export default isWellFormedReference;
